__turbopack_context__.v({
  "NotificationMessage__button": "NotificationMessage-module-scss-module__26-ira__NotificationMessage__button",
  "NotificationMessage__image": "NotificationMessage-module-scss-module__26-ira__NotificationMessage__image",
  "NotificationMessage__text": "NotificationMessage-module-scss-module__26-ira__NotificationMessage__text",
  "notificationMessage": "NotificationMessage-module-scss-module__26-ira__notificationMessage",
});
